import { render } from "./Countdown.vue?vue&type=template&id=c3a82cea"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"
script.render = render

export default script